import Homebutton from "../Homebutton";

function Meetwaarden() {
  return (
    <div className='container'>
      <div className='container-box'>
        <section>
          <h2>Meetwaarden voor het aansturen van Ondergronds</h2>
          <p>
            Wanneer je ondergronds aan kunt sturen hangt van een aantal metingen
            af we hebben de VCI en de langsweerstand meting. De VCI meting
            moeten aan de volgende eisen voldoen:
          </p>

          <ul>
            <li>Vreemde spanning &lt; 3V</li>
            <li>Capiciteit tussen de aders &lt; 3&#x25;</li>
            <li>Isolatie moet &gt; 3M&#x2126; zijn</li>
          </ul>

          <p>
            Mocht deze waardes niet voldoen aan de bovenstaande eisen sla dan al
            je metingen netjes op in je voortgang en bel met de Monteurs Ingang
            om ondergronds aan te sturen.
          </p>
        </section>
        <div className='questionBox'>
          <section>
            <h2>Uitgebreide informatie over de capiciteitsmeting</h2>
            <p>
              Onderlinge afwijking tussen aders t.o.v. referentieader op een
              open ader zonder apparatuur gekoppeld zoals dslam!
            </p>
            <p>
              Gemeten over dezelfde referentie ader of KPN aarde A-G/B-G. <br />
              Grenswaarde: &lt;1 nF of &lt;3&#x25; (lengte afhankelijk).
            </p>

            <table>
              <thead>
                <tr>
                  <th>Capaciteit A-B</th>
                  <th>
                    Maximaal verschil <br /> A-G/B-G
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>minder dan 35 nF</td>
                  <td>1 nF</td>
                </tr>
                <tr>
                  <td>tussen de 35 en 56 nF</td>
                  <td>2 nF</td>
                </tr>
                <tr>
                  <td>tussen de 56 en 80 nF</td>
                  <td>3 nF</td>
                </tr>
                <tr>
                  <td>tussen de 80 en 105 nF</td>
                  <td>4 nF</td>
                </tr>
                <tr>
                  <td>tussen de 105 en 130 nF</td>
                  <td>5 nF</td>
                </tr>
                <tr>
                  <td>tussen de 130 en 158 nF</td>
                  <td>6 nF</td>
                </tr>
                <tr>
                  <td>tussen de 158 en 175 nF</td>
                  <td>7 nF</td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
        <div className='questionBox'>
          <section>
            <h2>Langsweerstand meting</h2>
            <p>
              Langsweerstand: Onderlinge afwijking tussen aders t.o.v. de
              referentieader.
            </p>

            <p>
              Gemeten over dezelfde referentie ader <br />
              Grenswaarde: &lt; 1 Ω of &lt;3&#x25; (lengte afhankelijk)
            </p>
            <table>
              <thead>
                <tr>
                  <th>
                    Lus weerstand
                    <br />
                    A-B in ohm
                  </th>
                  <th>
                    Maximaal verschil <br /> A-G/B-G in ohm
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>minder dan 86&#x2126;</td>
                  <td>1&#x2126;</td>
                </tr>
                <tr>
                  <td>tussen de 86&#x2126; en 172&#x2126;</td>
                  <td>2&#x2126;</td>
                </tr>
                <tr>
                  <td>tussen de 172&#x2126; en 225&#x2126;</td>
                  <td>3&#x2126;</td>
                </tr>
                <tr>
                  <td>tussen de 225&#x2126; en 300&#x2126;</td>
                  <td>4&#x2126;</td>
                </tr>
                <tr>
                  <td>tussen de 300&#x2126; en 360&#x2126;</td>
                  <td>5&#x2126;</td>
                </tr>
                <tr>
                  <td>tussen de 360&#x2126; en 430&#x2126;</td>
                  <td>6&#x2126;</td>
                </tr>
                <tr>
                  <td>tussen de 430&#x2126; en 500&#x2126;</td>
                  <td>7&#x2126;</td>
                </tr>
                <tr>
                  <td>tussen de 500&#x2126; en 550&#x2126;</td>
                  <td>8&#x2126;</td>
                </tr>
                <tr>
                  <td>tussen de 550&#x2126; en 620&#x2126;</td>
                  <td>9&#x2126;</td>
                </tr>
                <tr>
                  <td>tussen de 620&#x2126; en 690&#x2126;</td>
                  <td>10&#x2126;</td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
        <Homebutton />
      </div>
    </div>
  );
}

export default Meetwaarden;
